import { useEffect, useState } from "react";

export interface TorahText {
  originalText: string;
  posmap: Int32Array;
}

export function useTorahText(): { text: TorahText | null; error: string | null } {
  const [text, setText] = useState<TorahText | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const base = (import.meta.env.BASE_URL ?? "/") as string;
        const [textRes, posmapRes] = await Promise.all([
          fetch(`${base}index/torah.text.txt`),
          fetch(`${base}index/torah.posmap.bin`),
        ]);
        if (!textRes.ok) throw new Error("Failed to load torah.text.txt");
        if (!posmapRes.ok) throw new Error("Failed to load torah.posmap.bin");
        const originalText = await textRes.text();
        const buf = await posmapRes.arrayBuffer();
        const posmap = new Int32Array(buf);
        if (!cancelled) setText({ originalText, posmap });
      } catch (e) {
        if (!cancelled) setError(e instanceof Error ? e.message : String(e));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { text, error };
}
